import LoaderComponent from "./Loader.vue";
import Loader from "./Loader";

export default {
    install(Vue) {
        let app = new Vue({
            data: {
              loader: new Loader()
            }
        });
        Vue.prototype.$loader = app.loader;
        Vue.component('loader', LoaderComponent);
      }
}
  